import styled from 'styled-components';

export default styled.div`
  background: ${({ theme }) => theme.palette.background.level1};
  padding-top: 50px;
  padding-bottom: 430px;
`;
